import { render, staticRenderFns } from "./management-workspace-members-view.vue?vue&type=template&id=1d3510ca&scoped=true&"
import script from "./management-workspace-members-view.vue?vue&type=script&lang=js&"
export * from "./management-workspace-members-view.vue?vue&type=script&lang=js&"
import style0 from "./management-workspace-members-view.vue?vue&type=style&index=0&id=1d3510ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d3510ca",
  null
  
)

export default component.exports